import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardStateInputBlock } from "./RewardStateInputBlock";

/**
 * Block used to generate the final reward
 */
export class RewardStateOutputBlock extends RewardGraphNode {
    _stateName : string;
    private _sinks : RewardStateInputBlock[] = [];

    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this._stateName = "state_" + this.uniqueId.toFixed(0);
        this.registerInput("state", RewardGraphConnectionPointTypes.AutoDetect);
        /*
        this.stateValue.onConnectionObservable.add( ()=>{
            console.log( this._sinks, this.stateValue.type );
            const detachers = this._sinks.map<RewardStateInputBlock|undefined>( (s)=>{
                console.log( s.stateValue.type, this.stateValue.type );
                if( s.stateValue.type != this.stateValue.type ) {
                    return s;
                }
                return undefined;
            }).filter<RewardStateInputBlock>((s) : s is RewardStateInputBlock => s!==undefined)
            console.log( detachers );
            detachers.forEach( (d)=>this.detachFromSink(d) );
        });
        */
    }

    public get stateName() {
        return this._stateName;
    }

    public set stateName(n:string) {
        this._stateName = n;
    }

    public get sinks() : RewardStateInputBlock[] {
        return this._sinks;
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardStateOutputBlock";
    }
    /**
     * Gets the reward input component
     */
    public get stateValue(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock(state: RewardGraphBuildState) {
        state.captureState(this.stateName, this.stateValue.getConnectedValue(state) );
    }

    protected override _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.stateName = ${this.stateName};\n`;
        return codeString;
    }

    override get isStateSource(): boolean {
        return true;
    }

    public attachToSink(sink: RewardStateInputBlock) {
        sink.detach();

        this._sinks.push(sink);
        sink.source = this;
        sink.stateValue._typeConnectionSource = this.stateValue;
        sink._tempStateSourceUniqueId = null;
    }

    public detachFromSink(sink: RewardStateInputBlock) {
        const index = this._sinks.indexOf(sink);

        if (index !== -1) {
            this._sinks.splice(index, 1);
            sink.stateValue._typeConnectionSource = null;
            sink.source = null;
        }
    }

    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */
    public override serialize(): any {
        const serializationObject = super.serialize();
        serializationObject.stateName = this.stateName;

        return serializationObject;
    }

    public override _deserialize(serializationObject: any) {
        super._deserialize(serializationObject);
        this.stateName = serializationObject.stateName;
    }
}

RegisterClass("MELS.RewardStateOutputBlock", RewardStateOutputBlock);
